import type { PiiEntry } from '@festina/legalentity-general-types/legalentity'
import { PiiEntriesTextService } from '@festina/legalentity-general-types/legalentity/services/PiiEntriesTextService'
import { useFestinaMutation } from '@festina-life/authentication'

export const useSubmitPiiEntries = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles: PiiEntriesTextService.piiEntriesServicePostEntity_roles,
    isScenario: false,
    mutateFunction: async (arg: PiiEntry) =>
      await PiiEntriesTextService.piiEntriesServicePostEntity({
        xTenantId: tenantId,
        requestBody: arg,
      }),
  })
